import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../views/Index.vue'
import User from '../views/sys/User.vue'
import Role from '../views/sys/Role.vue'
import Menu from '../views/sys/Menu.vue'

import axios from "../axios"
import store from "../store"
import el from "element-ui/src/locale/lang/el";

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    children: [{
        path: '/index',
        name: 'Index',
        meta: {
          title: "首页"
        },
        component: Index
      },
      {
        path: '/userCenter',
        name: 'UserCenter',
        meta: {
          title: "个人中心"
        },
        component: () => import('@/views/UserCenter.vue')
      },
      {
        path: '',
        redirect: 'index'
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/suggComplain',
    name: 'Complaints',
    component: () => import('@/views/Complaints.vue')
  },
  {
    path: '/reportMarket',
    name: 'ReportMarket',
    component: () => import('@/views/ReportMarket.vue')
  },
  {
    path: '/reportDetail/:id',
    name: 'ReportDetail',
    component: () => import('@/views/ReportDetail.vue')
  },
  {
    path: '/other',
    name: 'Other',
    component: () => import('@/views/Other.vue'),
    children: [{
        path: 'bg',
        name: 'BG',
        component: () => import('@/views/other/BG.vue')
      },
      {
        path: 'remind',
        name: 'Remind',
        component: () => import('@/views/other/Remind.vue')
      },
      {
        path: 'code',
        name: 'Code',
        component: () => import('@/views/other/Code.vue')
      },
      {
        path: 'appointment',
        name: 'Appointment',
        component: () => import('@/views/other/Appointment.vue')
      },
      {
        path: 'map',
        name: 'Map',
        component: () => import('@/views/other/Map.vue')
      },
      {
        path: 'global',
        name: 'Global',
        component: () => import('@/views/other/Global.vue')
      },
      {
        path: 'globalY',
        name: 'GlobalY',
        component: () => import('@/views/other/GlobalY.vue')
      },
      {
        path: 'globalC',
        name: 'GlobalC',
        component: () => import('@/views/other/GlobalC.vue')
      },
      {
        path: 'globalP',
        name: 'GlobalP',
        component: () => import('@/views/other/GlobalP.vue')
      },
      {
        path: '/other/target/:id',
        name: 'Target',
        component: () => import('@/views/other/Target.vue')
      },
      {
        path: 'questionnaire',
        name: 'Questionnaire',
        component: () => import('@/views/other/Questionnaire.vue')
      },
      {
        path: 'maintain',
        name: 'Maintain',
        component: () => import('@/views/other/Maintain.vue')
      },
      {
        path: 'maintainS',
        name: 'MaintainS',
        component: () => import('@/views/other/MaintainS.vue')
      },
      {
        path: 'download',
        name: 'Download',
        component: () => import('@/views/other/Download.vue')
      },
      {
        path: 'integralM',
        name: 'IntegralM',
        component: () => import('@/views/other/IntegralM.vue')
      },
      {
        path: '',
        redirect: 'bg'
      }
    ]
  },
  {
    path: '/year',
    component: () => import('@/views/Year.vue'),
    children: [{
        path: 'year01',
        name: 'Year01',
        component: () => import('@/views/year/Year01.vue')
      },{
        path: 'year02',
        name: 'Year02',
        component: () => import('@/views/year/Year02.vue')
      },{
        path: 'year03',
        name: 'Year03',
        component: () => import('@/views/year/Year03.vue')
      },{
        path: 'year04',
        name: 'Year04',
        component: () => import('@/views/year/Year04.vue')
      },{
        path: 'year05',
        name: 'Year05',
        component: () => import('@/views/year/Year05.vue')
      },{
        path: 'year06',
        name: 'Year06',
        component: () => import('@/views/year/Year06.vue')
      },{
        path: 'year07',
        name: 'Year07',
        component: () => import('@/views/year/Year07.vue')
      },{
        path: 'year08',
        name: 'Year08',
        component: () => import('@/views/year/Year08.vue')
      },{
        path: 'year09',
        name: 'Year09',
        component: () => import('@/views/year/Year09.vue')
      },{
        path: 'year10',
        name: 'Year10',
        component: () => import('@/views/year/Year10.vue')
      },{
        path: 'year11',
        name: 'Year11',
        component: () => import('@/views/year/Year11.vue')
      },
      {
        path: '',
        redirect: 'year01'
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: 'bms',
  routes
});


router.beforeEach((to, from, next) => {
  let hasRoute = store.state.menus.hasRoutes
  let token = localStorage.getItem("token")
  if (to.path == '/suggComplain' || to.path == '/reportMarket' || to.path.indexOf('/reportDetail') !== -1 || to.path
    .indexOf('/other') !== -1 || to.path.indexOf('/year') !== -1) {
    next()
  } else {
    if (to.path == '/login') {
      next()
    } else if (!token) {
      next({
        path: '/login'
      })
    } else if (token && !hasRoute) {
      next()
    }
    next()
  }

})


export default router
